<template>
    <!-- Add TaskWorkflow Modal -->
    <div class="modal fade" id="addTaskWorkflowModal" ref="addTaskWorkflowModal" tabindex="-1" aria-labelledby="taskModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-lg" style="max-width: 900px;">
            <div class="modal-content border-0">
                <div class="modal-header p-3 bg-soft-info">
                    <h5 class="modal-title" id="taskModalLabel"><template v-if="workflow!=null">Edit</template><template v-else>Add</template> Task Workflow</h5>
                    <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close">&times;</button>
                </div>
                <div class="modal-body">
                    <div class="alert alert-success" role="alert" v-if="successMessage">
                        {{ successMessage }}
                    </div>

                    <div v-if="commonErrors.length !=0" class="alert alert-danger alert-dismissible">
                        <a href="javascript:void(0);" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                        <ul>
                            <li v-for="(v, k) in commonErrors" :key="k">
                                <p v-for="error in v" :key="error" class="text-sm">
                                    {{ error }}
                                </p>
                            </li>
                        </ul>
                    </div>

                    <ValidationObserver v-slot="{ handleSubmit }" ref="formValidation" name="addTaskWorkflow">
                        <form @submit.prevent="handleSubmit(submitHandler)" enctype="multipart/form-data">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="mb-3">
                                        <label class="form-label">Event</label>
                                        <ValidationProvider name="Event" rules="required" v-slot="{ errors }">
                                            <select class="form-control" v-model="form.task_event_id">
                                                <option :value="null">Select</option>
                                                <option v-for="(item) in events" :value="item.id">{{item.name}}</option>
                                            </select>
                                            <div class="error" v-if="errors.length">{{ errors[0] }}</div>
                                        </ValidationProvider>

                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="mb-3">
                                        <label class="form-label">Rule</label>
                                        <select class="form-control" :readonly="rules.filter((x) => form.task_event_id && x.task_event_id == form.task_event_id).length ==0" v-model="form.task_event_rule_id">
                                            <option :value="null">Select</option>
                                            <option v-for="(item) in rules.filter((x) => form.task_event_id && x.task_event_id == form.task_event_id)" :value="item.id">{{item.rule}}</option>
                                        </select>

                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="mb-3">
                                        <label class="form-label">Module</label>
                                        <ValidationProvider name="Module" rules="required" v-slot="{ errors }">
                                            <select class="form-control" v-model="form.module">
                                                <option :value="null">Select</option>
                                                <option value="1">Sales Order</option>
                                                <option value="2">Purchase Order</option>
                                            </select>
                                            <div class="error" v-if="errors.length">{{ errors[0] }}</div>
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="mt-3">
                                        <label class="form-label">SO Status Change</label>
                                        <select class="form-select" v-model="form.so_status_id">
                                            <option :value="null">Select</option>
                                            <option v-for="(item, index) in soStatuses" :value="item.id">
                                                {{ item.name }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="mt-3">
                                        <label class="form-label">PO Status Change</label>
                                        <select class="form-select" v-model="form.po_status_id">
                                            <option :value="null">Select</option>
                                            <option v-for="(item, index) in poStatuses" :value="item.id">
                                                {{ item.name }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="mt-3">
                                        <label class="form-label">Task Type</label>
                                        <ValidationProvider name="Task Type" rules="required" v-slot="{ errors }">
                                            <select class="form-control" v-model="form.is_create">
                                                <option :value="null">Select</option>
                                                <option value="1">Create Task</option>
                                                <option value="2">Close Task</option>
                                            </select>
                                            <div class="error" v-if="errors.length">{{ errors[0] }}</div>
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="mt-3">
                                        <label class="form-label">Priority</label>
                                        <ValidationProvider name="Priority" rules="required" v-slot="{ errors }">
                                            <select class="form-control" v-model="form.priority_id">
                                                <option :value="null">Select</option>
                                                <option v-for="(item, index) in priorities" :value="item.id">
                                                    {{ item.priority_name }}
                                                </option>
                                            </select>
                                            <div class="error" v-if="errors.length">{{ errors[0] }}</div>
                                        </ValidationProvider>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="mb-3">
                                        <label class="form-label">Task</label>
                                        <ValidationProvider name="Title" rules="required" v-slot="{ errors }">
                                            <input type="text" class="form-control" v-model="form.name" />
                                            <div class="error" v-if="errors.length">{{ errors[0] }}</div>
                                        </ValidationProvider>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <label class="form-label">Task Description</label>
                                    <textarea class="form-control" style="height: 80px" v-model="form.description"></textarea>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-3" v-if="form.module == 2">
                                    <div class="mt-3">
                                        <div class="custom-control custom-checkbox">
                                            <input type="checkbox" class="custom-control-input" v-model="form.show_on_so" id="show_on_so" name="show_on_so">
                                            <label class="custom-control-label" for="show_on_so">Show On SO</label>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-3" v-if="form.module == 1">
                                    <div class="mt-3">
                                        <div class="custom-control custom-checkbox">
                                            <input type="checkbox" class="custom-control-input" v-model="form.show_on_po" id="show_on_po" name="show_on_po">
                                            <label class="custom-control-label" for="show_on_po">Show On PO</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="mt-3 text-end">
                                <button type="submit" :disabled="loading" class="btn btn-primary fw-semibold fs-14 px-4">Save</button>
                            </div>
                        </form>
                    </ValidationObserver>

                </div>
            </div>
        </div>
    </div>

</template>

<script>
import {ValidationProvider, ValidationObserver, extend, configure} from 'vee-validate';
import axios from "axios";
import DatePicker from "vue2-datepicker";
import {mapActions, mapGetters, mapState} from "vuex";

configure({
    classes: {
        valid: 'is-valid',
        invalid: 'is-invalid',
        dirty: ['is-dirty', 'is-dirty'], // multiple classes per flag!
        // ...
    }
});

extend('positive', value => {
    if (value >= 0) {
        return true;
    }

    return 'This field must be a positive number';
});

export default {
    name: "AddTaskWorkflow",
    props:['workflow', 'loading', 'events', 'soStatuses', 'poStatuses', 'priorities', 'rules'],
    components:{
        ValidationObserver, ValidationProvider,
        DatePicker
    },
    created() {
    },
    mounted() {
        let self = this;
        $("#addTaskWorkflowModal").on('show.bs.modal', () => {
            if(self.workflow) {
                self.form.task_event_id = self.workflow.task_event_id;
                self.form.module = self.workflow.module;
                self.form.name = self.workflow.name;
                self.form.description = self.workflow.description;
                self.form.status_module = self.workflow.status_module;
                self.form.so_status_id = self.workflow.so_status_id;
                self.form.po_status_id = self.workflow.po_status_id;
                self.form.is_create = self.workflow.is_create;
                self.form.priority_id = self.workflow.priority_id;
                self.form.is_red = self.workflow.is_red;
                self.form.show_on_so = self.workflow.show_on_so;
                self.form.show_on_po = self.workflow.show_on_po;

                setTimeout(() => {
                    self.form.task_event_rule_id = self.workflow.task_event_rule_id;
                }, 100);
            }
        });

        $('#addTaskWorkflowModal').on('hidden.bs.modal', function () {
            self.form = {
                task_event_id: null,
                task_event_rule_id: null,
                module: null,
                name: null,
                description: null,
                status_module: null,
                so_status_id: null,
                po_status_id: null,
                is_create: 1,
                priority_id: null,
                is_red: false,
                show_on_so: false,
                show_on_po: false,
            };
            self.$refs.formValidation.reset();
        });
    },
    data(){
        return {
            form: {
                task_event_id: null,
                task_event_rule_id: null,
                module: null,
                name: null,
                description: null,
                status_module: null,
                so_status_id: null,
                po_status_id: null,
                is_create: 1,
                priority_id: null,
                is_red: false,
                show_on_so: false,
                show_on_po: false,
            },
        };
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setLoading',
        ]),
        submitHandler() {
            this.$refs.formValidation.validate().then(success => {
                if (!success) {
                    return;
                }

                let self = this;
                this.setLoading(true);
                this.setCommonErrors([]);
                this.setErrorMessage(null);

                if(this.workflow) {
                    return axios.put(window.route('task-workflows.update', {id: this.workflow.id}), this.form,{

                        validateStatus: function (status) {
                            return status < 500; // Resolve only if the status code is less than 500
                        }
                    })
                        .then(({data}) => {
                            if (data.errors && Object.keys(data.errors).length) {
                                self.setCommonErrors(data.errors);
                            } else if (data.errorMessage) {
                                self.setErrorMessage(data.errorMessage);
                            } else {
                                self.setSuccessMessage('Workflow updated!');
                                setTimeout(() => {
                                    self.setSuccessMessage(null);
                                }, 5000);
                                self.$emit('updatedEvent', data);
                            }
                        })
                        .catch((error) => {
                            self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                        })
                        .finally(() => {
                            self.setLoading(false);

                        });
                } else {
                    return axios.post(window.route('task-workflows.store'), this.form,{

                        validateStatus: function (status) {
                            return status < 500; // Resolve only if the status code is less than 500
                        }
                    })
                        .then(({data}) => {
                            if (data.errors && Object.keys(data.errors).length) {
                                self.setCommonErrors(data.errors);
                            } else if (data.errorMessage) {
                                self.setErrorMessage(data.errorMessage);
                            } else {
                                self.setSuccessMessage('Workflow created!');
                                setTimeout(() => {
                                    self.setSuccessMessage(null);
                                }, 5000);
                                self.$emit('addedEvent', data);
                            }
                        })
                        .catch((error) => {
                            self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                        })
                        .finally(() => {
                            self.setLoading(false);

                        });
                }
            });
        },
    },
    computed: {
        ...mapGetters([
            'commonErrors',
            'errorMessage',
            'successMessage'
        ])
    },
    watch: {
        'form.task_event_id': {
            handler: function (value) {
                this.form.task_event_rule_id = null;
            }
        },
    }
}
</script>

<style scoped>

</style>
